// extracted by mini-css-extract-plugin
module.exports = {"latest-article-wrapper":"SeriesArticles_latest-article-wrapper__PtXLm"};